import React, { Component } from 'react'
import {
  Layout,
  Button,
  Icon,
  Carousel,
  Anchor,
  Tag,
  Menu,
  Dropdown,
} from 'antd'
import { withTranslation } from 'react-i18next'
import './index.css'
import bg from '../../../assets/images/pro-down-bg.png'
import i18n from "i18next";
const { Link } = Anchor
const { Content } = Layout

class NotFound extends Component {
  constructor(props) {
    super(props)
    this.state = {
      buttons: [
        {
          value: 'p_detail_05',
          code: 'zhCN',
          active: false,
          exe:
            'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
          // 'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
          lan: 'dl',
        },
        {
          value: 'tw',
          code: 'zhTW',
          active: false,
          exe:
            'https://es-update.digiwin.com/installer/SCP/SCP.Desktop.Setup.exe',
          lan: 'tw',
        },
        {
          value: 'mlxy',
          code: 'zhEN',
          active: false,
          exe:
            'https://es-update.digiwin.com/installer/SCP/MY.SCP.Desktop.Setup.exe',
          lan: 'mlxy',
        },
        {
          value: 'yn',
          code: 'zhVN',
          active: false,
          exe:
            'https://es-update.digiwin.com/installer/SCP/VN.SCP.Desktop.Setup.exe',
          lan: 'yn',
        },
        {
          value: 'tg',
          code: 'zhTHAI',
          active: false,
          exe:
            'https://es-update.digiwin.com/installer/SCP/TH.SCP.Desktop.Setup.exe',
          lan: 'tg',
        },
      ],
      edition: 'dl',
      exe:
        'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
      // 'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
      lan: 'dl',
    }

  }

  componentDidMount() {
    // debugger
    let hostname = window.location.hostname
    if (hostname === 'es-ygj.digiwincloud.com') {
      this.setState({
        edition: 'tw',
        lan: 'tw',
        exe: 'https://es-update.digiwin.com/installer/SCP/SCP.Desktop.Setup.exe',
      })
    } else {
      this.setState({
        edition: 'dl',
        lan: 'dl',
        exe:
          'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
        //'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',
      })
    }
  }
  loadDown = (data) => {
    let buttons = this.state.buttons.map((item) => {
      item.active = false
      if (item.code === data.code) {
        item.active = true
        this.setState({
          edition: item.value,
          exe: item.exe,
          lan: item.lan,
        })
      }
      return item
    })

    this.setState({
      buttons: buttons,
    })
  }
  handleLoad = () => {
    window.location.href = this.state.exe
  }
  render() {
    const { t } = this.props

    const topClass = window.location.hostname === 'es-ygj.digiwincloud.com' || i18n.language != 'zhCN' ? "q-linear-bg-tw" : "q-linear-bg"
    //  const topBg=window.location.hostname==='es-ygj.digiwincloud.com'? "../../../assets/product-bg_tw.png": "../../../assets/product-bg_tw.png"
    // const topStyle = {
    //   backgroundImage: 'url(' + topBg + ')',
    // }

    const menu = (
      <Menu>
        {this.state.buttons.map((item) => {
          return (
            <Menu.Item key={item.code}>
              <a rel="noopener noreferrer" onClick={() => this.loadDown(item)}>
                {t(item.value)}
              </a>
            </Menu.Item>
          )
        })}
      </Menu>
    )
    return (
      <Content className="q-content-wrapper">
        <div className={topClass}></div>
        <div className="q-main" style={{ padding: '165px' }}>
          <div className="q-product-content">
            <img src={bg} style={{ flexShrink: 0, height: '344px' }} />
            <div className="q-product-detail">
              <div className="q-box">
                <h2>
                  {t('service')}
                  <span className="active-108"> {t('cloud')}</span>{' '}
                  {t('manager')}
                </h2>
                <div style={{ paddingLeft: '20px' }}>
                  <Dropdown overlay={menu}>
                    <span
                      className="ant-dropdown-link"
                      onClick={(e) => e.preventDefault()}
                    >
                      <Button type="primary" className="q-button-group">
                        {t(this.state.lan)}
                        <Icon type="down" />
                      </Button>
                    </span>
                  </Dropdown>
                </div>
                {/* <Tag color="#108ee9">{t(this.state.edition)}</Tag> */}
              </div>
              <p className="q-details">{t('title_detail')}</p>
              <p className="q-details q-mini">
                {t('p_detail_01')}
                <span className="active-108"> {t('p_detail_02')}</span>
                {t('p_detail_03')}
              </p>
              <p className="q-details q-mini q-icon">
                <Icon type="global" style={{ marginRight: '5px' }} />
                {t('p_detail_04')}： {t(this.state.edition)}
              </p>
              <Button
                type="define-button-primary"
                size="large"
                style={{ marginLeft: '0' }}
                onClick={() => this.handleLoad()}
              >
                <Icon type="download" className="f26" />
                {t('button_download')}
              </Button>
            </div>
          </div>
        </div>
      </Content>
    )
  }
}
export default withTranslation()(NotFound)
